/**
 * Whether the sample layers may INVENT anything — one switch for the directory, the Home and the
 * Organization profile stand-ins.
 *
 * Daniel Samper, 1 Oct 2026, before a client demo: *"Let's remove all Demo data and the fake
 * connection requests data and the demo data capsules from all directories … let's only include
 * real data in the external contacts or glotwise marketplace"* and *"when a new organization gets
 * invited and starts in the platform, we already assign them fake data. We need to clear all of
 * that too."*
 *
 * With this `false` the interceptors still run, but only for what is not invented:
 * - a real value derived from real data (a task's real project id, a listing's credential);
 * - answers built from rows the page has really loaded (Add contact's lookup);
 * - empty starting points for settings nobody can store yet, plus what the reader typed this
 *   session — so setup forms keep working instead of failing on a missing endpoint.
 *
 * Every other missing endpoint answers its real 404 and the page shows its empty state; every
 * missing field stays missing. Nothing is labelled "Demo data" / "Sample data" for an empty answer.
 *
 * Flip it to `true` to bring every seeded demo back exactly as it was.
 */
export const INVENTED_DATA_ENABLED = false;
